import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SendMoneyService } from '../send-money.service';
import { CommonService } from 'src/app/services/common.service';
import {MessageService} from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';

declare var webengage
@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.scss']
})
export class Step2Component implements OnInit {
  caPurposeTitle
  reason_code=""
  constructor(public auth:AuthService, public sendMoneyService:SendMoneyService,public router:Router, public common:CommonService, public messageService:MessageService) { }

  ngOnInit(): void {
    
    if(!(this.sendMoneyService.receiver)){
      this.sendMoneyService.goTo("step1")
    }else{
      webengage.track("recipient_selection",{
        "Reciever name" : `${this.sendMoneyService.receiver.first_name || this.sendMoneyService.receiver.payee_name} ${this.sendMoneyService.receiver.last_name || ''}`,
        "To country id" : this.sendMoneyService.receiver.country_id || this.sendMoneyService.receiver.payee_country,
        "From country (user country)" : this.auth.user.country_id,
      })
      this.sendMoneyService.isMarkPurpose=true
    }
    if(this.sendMoneyService.purpose?.reason_code){
      this.reason_code=this.sendMoneyService.purpose.reason_code
    }


    
  }
  onpurposeFormSubmit(purposeForm){

    //console.log(purposeForm.value);
    if(this.auth.user.country_id==39){
      this.caPurposeTitle = this.sendMoneyService.caReasons.find(element=>{
        //console.log(element.attributes.code)
        return  this.reason_code==element.attributes.code
      }).attributes.reason
      purposeForm.value.remittance_purpose=this.caPurposeTitle
    }
    this.sendMoneyService.purpose=purposeForm.value
    this.sendMoneyService.goTo("step3")
  }

  goBack(){
    this.sendMoneyService.goTo("step1")
    //this.sendMoneyService.isMarkPurpose=false
  }



}
